import { UserRole, UserPermissionDto } from 'shared/types/userRole';
import { UserInDto, UserWithPermissionsInDto } from './inDto';

export type UserEditApiResponse = UserInDto | UserWithPermissionsInDto;

function isUserPermissionDto(value: unknown): value is UserPermissionDto {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  if ('role' in value && value.role === UserRole.superAdmin) {
    return true;
  }

  return 'clients' in value && Array.isArray(value.clients);
}

export function isUserWithPermissionsInDto(
  user: unknown
): user is UserWithPermissionsInDto {
  if (typeof user !== 'object' || user === null) {
    return false;
  }

  if (!('_id' in user) || typeof user._id !== 'string') {
    return false;
  }

  if (!('email' in user) || typeof user.email !== 'string') {
    return false;
  }

  if (!('permissions' in user) || !Array.isArray(user.permissions)) {
    return false;
  }

  if (
    !('basePermissions' in user) ||
    !isUserPermissionDto(user.basePermissions)
  ) {
    return false;
  }

  if (!('personalData' in user) || !Array.isArray(user.personalData)) {
    return false;
  }

  return true;
}
